<div class="wrapper">
        <h1>Oops!</h1>
        <h2>404 Not Found</h2>
</div>